import {alias, createModelSchema, list} from "serializr";
import {Schema} from "@/common/Schema";

import {SmartOfferBundle} from "../bundle-core/SmartOfferBundle";
import {SmartOfferBundleKind} from "../bundle-core/SmartOfferBundleKind";
import {RewardBunch} from "@/modules/redactor/models/reward/RewardBunch";
import {CurrencyKindModel} from "@/modules/redactor/models/currency/CurrencyKindModel";
import {SmartOfferBundleAlchemyLevel} from "@/modules/redactor/models/smart-offer/bundle-alchemy/SmartOfferBundleAlchemyLevel";

export class SmartOfferBundleAlchemy extends SmartOfferBundle {

    constructor() {

        super(SmartOfferBundleKind.ALCHEMY);

        this._merge_currency_multiply = 1;

        this._merge_currency = null;
        this._bottle_currency = null;
        this._progress_currency = null;

        this._rewards = null;
        this._rewards_premium = null;

        this._rewards_exchange = null;

        this._product = null;
        this._levels = [];

    }

    get merge_currency_multiply() {
        return this._merge_currency_multiply;
    }
    set merge_currency_multiply(value) {
        this._merge_currency_multiply = value;
    }

    get merge_currency() {
        return this._merge_currency;
    }
    set merge_currency(value) {
        this._merge_currency = value;
    }

    get bottle_currency() {
        return this._bottle_currency;
    }
    set bottle_currency(value) {
        this._bottle_currency = value;
    }

    get progress_currency() {
        return this._progress_currency;
    }
    set progress_currency(value) {
        this._progress_currency = value;
    }

    get rewards() {
        return this._rewards;
    }
    set rewards(value) {
        this._rewards = value;
    }

    get rewards_premium() {
        return this._rewards_premium;
    }
    set rewards_premium(value) {
        this._rewards_premium = value;
    }

    get rewards_exchange() {
        return this._rewards_exchange;
    }
    set rewards_exchange(value) {
        this._rewards_exchange = value;
    }

    get levels() {
        return this._levels;
    }
    set levels(value) {
        this._levels = value;
    }

    get product() {
        return this._product;
    }
    set product(value) {
        this._product = value;
    }

    valid() {

        if (!super.valid()) {
            return false;
        }

        if (!CurrencyKindModel.is(this.merge_currency)) {
            return false;
        }

        if (!CurrencyKindModel.is(this.bottle_currency)) {
            return false;
        }

        if (!CurrencyKindModel.is(this.progress_currency)) {
            return false;
        }

        if (!this.rewards || this.rewards.empty()) {
            return false;
        }

        if (this.rewards && !this.rewards.valid()) {
            return false;
        }

        if (!this.levels || this.levels.length === 0) {
            return false;
        }

        if (this.levels && this.levels.some(v => !v || !v.valid())) {
            return false;
        }

        if (!this.rewards_premium || this.rewards_premium.empty()) {
            return false;
        }

        if (this.rewards_premium && !this.rewards_premium.valid()) {
            return false;
        }

        if (this.rewards.length != this.rewards_premium.length) {
            return false;
        }

        if (!this.rewards_exchange || this.rewards_exchange.empty()) {
            return false;
        }

        if (this.rewards_exchange && !this.rewards_exchange.valid()) {
            return false;
        }

        return true;
    }

    empty() {

        if (!this.rewards || this.rewards.empty()) {
            return true;
        }

        return super.empty();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleAlchemy());
        } else if (target instanceof SmartOfferBundleAlchemy) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleAlchemy, {

    _merge_currency_multiply: alias("merge_currency_multiply", Schema.primitive()),

    _merge_currency: alias("merge_currency", CurrencyKindModel.schema()),
    _bottle_currency: alias("bottle_currency", CurrencyKindModel.schema()),
    _progress_currency: alias("progress_currency", CurrencyKindModel.schema()),

    _rewards: alias("rewards", RewardBunch.schema()),
    _rewards_premium: alias("rewards_premium", RewardBunch.schema()),

    _rewards_exchange: alias("rewards_exchange", RewardBunch.schema()),

    _levels: alias("levels", list(SmartOfferBundleAlchemyLevel.schema())),

    _product: alias("product", Schema.primitive()),
});

